import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { useInstance, createRef } from 'intact-vue';
import { isArray } from 'intact-shared';
import { toggleArray } from '../utils';
import { createContext } from '../context';
import { useState, watchState } from '../../hooks/useState';
export var context = createContext();
export function useGroup() {
  var instance = useInstance();
  var keywords = useState('');
  var filteredGroup = useState(instance.get('group'));
  var localGroupValue = useState(null);
  var dropdownRef = createRef();
  instance.on('$receive:group', function (group) {
    return filteredGroup.set(group);
  });
  function onShow(groupValue) {
    keywords.set('');
    localGroupValue.set(groupValue);
  }
  function onSelect(value, onChange) {
    var _instance$get = instance.get(),
      multiple = _instance$get.multiple,
      key = _instance$get.key;
    if (multiple) {
      // should click confirm button when it is multiple selection
      localGroupValue.set(toggleArray(localGroupValue.value, value));
    } else {
      // change immediately when it is single selection
      onChange(key, value);
    }
  }
  function isChecked(value) {
    var _instance$get2 = instance.get(),
      multiple = _instance$get2.multiple;
    var groupValue = localGroupValue.value;
    if (multiple) {
      return groupValue && _includesInstanceProperty(groupValue).call(groupValue, value);
    }
    return groupValue === value;
  }
  function confirm(onChange) {
    var _instance$get3 = instance.get(),
      key = _instance$get3.key;
    onChange(key, localGroupValue.value);
    dropdownRef.value.hide(true);
  }
  function reset(onChange) {
    localGroupValue.set([]);
    confirm(onChange);
  }
  function checkAll() {
    var _filteredGroup$value;
    localGroupValue.set((_filteredGroup$value = filteredGroup.value) == null ? void 0 : _mapInstanceProperty(_filteredGroup$value).call(_filteredGroup$value, function (item) {
      return item.value;
    }));
  }
  function isEmptyValue(groupValue) {
    var _instance$get4 = instance.get(),
      multiple = _instance$get4.multiple;
    return !groupValue || multiple && (!isArray(groupValue) || groupValue.every(function (value) {
      return !value;
    }));
  }
  watchState(keywords, function (v) {
    var _instance$get5 = instance.get(),
      _instance$get5$group = _instance$get5.group,
      group = _instance$get5$group === void 0 ? [] : _instance$get5$group;
    v = _trimInstanceProperty(v).call(v);
    if (!v) {
      filteredGroup.set(group);
    } else {
      filteredGroup.set(_filterInstanceProperty(group).call(group, function (item) {
        var _context, _context2;
        return _includesInstanceProperty(_context = String(item.label)).call(_context, v) || _includesInstanceProperty(_context2 = String(item.value)).call(_context2, v);
      }));
    }
  });
  return {
    onSelect: onSelect,
    isChecked: isChecked,
    keywords: keywords,
    filteredGroup: filteredGroup,
    onShow: onShow,
    reset: reset,
    confirm: confirm,
    dropdownRef: dropdownRef,
    localGroupValue: localGroupValue,
    isEmptyValue: isEmptyValue,
    checkAll: checkAll
  };
}